export default "__VITE_ASSET__DmTxNudv__"